import ms from 'ms';

import {
  BAYWA_SCREEN_USER,
  STRABAG_SUPPORT_USERS,
  SUPPLIER_OVERVIEW_USER,
} from '~/data/user/constants';

export const BROWSER_KEYS = ['chrome', 'firefox', 'safari'] as const;

export type BrowserKey = (typeof BROWSER_KEYS)[number];

export const MAX_FILE_BYTES = 10 * 1024 * 1024; // 10 MB
export const MAX_FILE_MB = MAX_FILE_BYTES / 1024 / 1024;
export const SCREENSHOT_ACCEPT = 'image/png,image/jpeg,image/webp';

export const DRAFT_TTL_MS = ms('5m');

/**
 * Email local-parts that indicate generic/system accounts rather than real people.
 */
export const GENERIC_EMAIL_LOCALS: ReadonlySet<string> = new Set([
  'admin',
  'muster',
  'polier',
  'sales',
  'service',
  'support',
  'vertrieb',
]);

export const SYSTEM_ACCOUNT_IDS: ReadonlySet<string> = new Set([
  BAYWA_SCREEN_USER,
  ...SUPPLIER_OVERVIEW_USER,
  ...STRABAG_SUPPORT_USERS,
]);
